const getBestVenueImages = (imagesByResolution, thumbnails = false) => {
  if (!imagesByResolution) return [];

  const imageIds = Object.keys(imagesByResolution) || {};

  const displayAspectRatioPreferences = ['4:3', '16:9', '1:1'];
  const displayResolutionPreferences = ['1600', '800', '400', '200'];

  const thumbnailAspectRatioPreferences = ['1:1', '4:3', '16:9'];
  const thumbnailResolutionPreferences = ['400', '800', '200', '1600'];

  const selectPreferredAspectRatio = (imageObj) => {
    const aspectPreference = thumbnails ? thumbnailAspectRatioPreferences : displayAspectRatioPreferences;
    const availableAspectRatios = Object.keys(imageObj);
    let output = null;
    for (let i = 0; i < aspectPreference.length; i++) {
      const currentAspectRatio = aspectPreference[i];
      const aspectRatioExistsForImage = availableAspectRatios.includes(currentAspectRatio);

      if (aspectRatioExistsForImage) {
        output = imageObj[currentAspectRatio];
        break;
      }
    }
    return output;
  };

  const returnHighestResolution = (image, imageId) => {
    const availableResolutions = Object.keys(image);

    const output = {
      id: imageId,
      url: null,
    };

    const resPreferences = thumbnails ? thumbnailResolutionPreferences : displayResolutionPreferences;
    for (let i = 0; i < resPreferences.length; i++) {
      const currentResolution = resPreferences[i];
      const resolutionExistsForImage = availableResolutions.includes(currentResolution);
      if (resolutionExistsForImage) {
        output.url = selectPreferredAspectRatio(image[currentResolution]);
        break;
      }
    }
    return output;
  };

  return imageIds.map((imageId) => returnHighestResolution(imagesByResolution[imageId], imageId));
};

export default getBestVenueImages;
